import React, { useState } from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import FormBadge from './FormBadge';
import { useMutation } from '@tanstack/react-query';
import { saveImage } from '../../services/badge';
import { showNotification } from '../../utilities/mantineNotification';
import { LoadingOverlay } from '@mantine/core';
import Loader from '../../components/fragments/Loader';

interface CreateBadgeProps {
  isVisible: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  data: any;
  type: string;
}

const CreateBadge: React.FC<CreateBadgeProps> = ({
  isVisible,
  onSubmit,
  onClose,
  loading,
  data,
  type
}) => {
  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });

  const uploadImage = useMutation({
    mutationFn: (data: any) =>
      saveImage({
        FileName: data.badgeImage.fileName,
        FileData: data.badgeImage.base64
      }),
    onSuccess: (response) => {
      const imageUrl = response.data.data.filePath;
      showNotification({
        type: 'success',
        title: 'Success Upload Image',
        message: 'Image has been uploaded'
      });
      setModalDialog({
        show: false,
        data: null
      });
      onSubmit({ ...modalDialog.data, badgeImage: imageUrl });
    },
    onError: (error: any) => {
      console.error('error', error);
      showNotification({
        type: 'error',
        message: error?.errorMessage
          ? JSON.stringify(error?.errorMessage)
          : 'Failed to upload image. Please change the image into .png/.jpg and try again.'
      });
    }
  });

  const handleSubmitData = (payload: any) => {
    setModalDialog({
      show: true,
      data: payload
    });
  };

  const handleConfirm = () => {
    if (modalDialog.data.badgeImage !== data.badgeImage) {
      const payload = {
        ...modalDialog.data,
        badgeImage: JSON.parse(modalDialog.data.badgeImage)
      };
      uploadImage.mutate(payload);
      return;
    }
    setModalDialog({
      show: false,
      data: null
    });
    onSubmit(modalDialog.data);
    return;
  };

  return (
    <>
      <ModalWrapper
        title={`${type === 'edit' ? 'Update' : 'Create'} Badge`}
        isVisible={isVisible}
        onClose={onClose}
      >
        <FormBadge
          onClose={onClose}
          loading={loading}
          handleSubmitData={handleSubmitData}
          type={type}
          data={data}
        />
      </ModalWrapper>

      <ModalConfirmation
        isVisible={modalDialog.show}
        type={type}
        onCancel={() => {
          setModalDialog({
            show: false,
            data: null
          });
        }}
        onConfirm={handleConfirm}
      />

      <LoadingOverlay
        visible={uploadImage.isLoading}
        loaderProps={{ children: <Loader message="Uploading image..." /> }}
      />
    </>
  );
};

export default CreateBadge;
